import React, { Component } from 'react'
import { utils_tool, component_tool } from "@/tool";
const { WizList, WizModal } = component_tool

export default class table extends Component {

    constructor(props){
        super(props)
        this.state = {
            dataSource: [{
                title: '河北邢台通报一无症状感染者',
                description: '（原标题：河北邢台通报一例无症状感染者：从美国入境 赴河南途中收治 公安机关已立案侦查）'
            },
            {
                title: '美国确诊病例升至近2万例',
                description: '据约翰·霍普金斯大学数据，截至美东时间20日19：43，美国确诊病例升至19101例，死亡244例。（央视记者王逢治）'
            },
            {
                title: '意大利单日新增确诊5986例',
                description: '证券时报e公司讯，截至当地时间20日18时，意大利24小时新增新冠肺炎确诊病例5986例。累计确诊47021例，死亡4032例，治愈5129例。现存37860例确诊病例中，重症2655例，居家隔离19185例。 (央视新闻)'
            }],
            visible: false
        }
    }
    
    componentDidMount() {
        const { messageEvent } = this.props
        messageEvent.on('showList', val => {
            this.setState({
                visible: true
            })
        })
    }

    closeModal = () => {
        this.setState({
            visible: false
        })
    }

    ok = () => {
        const { messageEvent } = this.props
        const { dataSource } = this.state 
        messageEvent.emit('listResult',dataSource)
        this.setState({
            visible: false
        })
    }

    render() {
        const { dataSource, visible } = this.state
        const listProps = {
            header: '列表标题',
            dataSource,
            renderItem: item => (
                <WizList.Item key={ item.name }>
                    <WizList.Item.Meta title = { item.title } description = { item.description } />
                </WizList.Item>
            )
        }

        const modalProps = {
            visible,
            onCancel: this.closeModal,
            onOk: this.ok,
        }
        return (
            <WizModal { ...modalProps } >
                <WizList { ...listProps } />
            </WizModal>
        )
    }
}
